import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

interface ValidationHelperResources {
	title: string;
}

interface ValidationHelperOutput {
	title: string;
}

export const useValidationHelper = (): ValidationHelperOutput => {
	const t = useTranslation();

	const resources: ValidationHelperResources = {
		title: t('modals.validation.title'),
	};

	return { title: resources.title };
};
